import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import PropTypes from 'prop-types';
import React from 'react';
import PrimaryButton from '../PrimaryButton';

class ReportDownload extends React.Component {

    state = {
        open: false
    };

    downloadReport = (format, includeHeaders) => this.props.onDownloadReport(format, includeHeaders);

    showMenu = (ev) => {
        this.setState({
            anchorEl: ev.currentTarget,
            open: true
        });
    };

    handleClose = (format, includeHeaders = false) => {
        this.setState({ open: false });
        if (format !== null) this.downloadReport(format, includeHeaders);
    };

    render() {

        const { disabled } = this.props;
        const { open, anchorEl } = this.state;

        return (
            <div>
                <PrimaryButton
                    disabled={disabled}
                    dataTest="download-report"
                    endIcon={<KeyboardArrowDownIcon />}
                    onClick={this.showMenu}>Download</PrimaryButton>
                <Menu
                    open={open}
                    anchorEl={anchorEl}
                    transformOrigin={{
                        horizontal: -5,
                        vertical: -46
                    }}
                    onClose={(ev) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        this.handleClose(null);
                    }}>
                    <MenuItem
                        data-test={"item-tsv"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("text/tab-separated-values");
                        }}
                        value="tsv">Download TSV</MenuItem>
                    <MenuItem
                        data-test={"item-tsv-headers"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("text/tab-separated-values", true);
                        }}
                        value="tsv">Download TSV including Header Row</MenuItem>
                </Menu>
            </div>
        );
    }
}

ReportDownload.defaultProps = {
    disabled: false
};

ReportDownload.propTypes = {
    disabled: PropTypes.bool,
    onDownloadReport: PropTypes.func.isRequired
};

export default ReportDownload;